module.exports = __webpack_public_path__ + "img/dialog-img-01.4e292681.png";